<template>
  <div class="container">
    <transition name="fade">
      <div v-if="rewidgvis" class="">
        <rewidg />
      </div>
    </transition>

    <transition name="fade">
      <div v-if="vandmvis" class="vandm-wrapper">
        <div class="vandm-card">
          <!-- Header -->
          <div class="vandm-header">
            <div class="vandm-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4a7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="1" y="3" width="15" height="13" rx="2"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
              </svg>
            </div>
            <h4 class="vandm-title">Vehicle Details</h4>
            <p class="vandm-subtitle">Enter your vehicle information to get started</p>
          </div>

          <!-- Qualification alert -->
          <div v-if="qualifyAlert" class="vandm-alert vandm-alert--danger">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
            <span>Sorry, the details you entered don't qualify for a repair payment plan.</span>
          </div>

          <!-- Step indicator -->
          <div class="vandm-steps">
            <div class="vandm-step" :class="{ 'vandm-step--active': !model.year, 'vandm-step--done': model.year }">
              <span class="vandm-step__dot"></span><span class="vandm-step__label">Year</span>
            </div>
            <div class="vandm-step__line" :class="{ 'vandm-step__line--done': model.year }"></div>
            <div class="vandm-step" :class="{ 'vandm-step--active': model.year && !model.make, 'vandm-step--done': model.make }">
              <span class="vandm-step__dot"></span><span class="vandm-step__label">Make</span>
            </div>
            <div class="vandm-step__line" :class="{ 'vandm-step__line--done': model.make }"></div>
            <div class="vandm-step" :class="{ 'vandm-step--active': model.make && !model.model, 'vandm-step--done': model.model }">
              <span class="vandm-step__dot"></span><span class="vandm-step__label">Model</span>
            </div>
            <div class="vandm-step__line" :class="{ 'vandm-step__line--done': model.model }"></div>
            <div class="vandm-step" :class="{ 'vandm-step--active': model.model && !odometer, 'vandm-step--done': odometer }">
              <span class="vandm-step__dot"></span><span class="vandm-step__label">KM</span>
            </div>
          </div>

          <!-- Form fields -->
          <div class="vandm-form">
            <!-- Year -->
            <div class="vandm-field">
              <label class="vandm-label">Year</label>
              <div v-if="!apiError" class="vandm-select-wrap">
                <select ref="ymminput" v-model="model.year" class="vandm-select" @change="yearChanged()">
                  <option value="">Select year</option>
                  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
                <svg class="vandm-select-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </div>
              <input v-else ref="ymminput" v-model="model.year" class="vandm-input" placeholder="Type year here" />
            </div>

            <!-- Make -->
            <div class="vandm-field">
              <label class="vandm-label">Make</label>
              <div v-if="!apiError" class="vandm-select-wrap">
                <select v-model="model.make" class="vandm-select" :disabled="!makes.length" @change="makeChanged()">
                  <option value="">Select make</option>
                  <option v-for="make in makes" :key="make" :value="make">{{ make }}</option>
                </select>
                <svg class="vandm-select-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </div>
              <input v-else v-model="model.make" class="vandm-input" placeholder="Type make here" />
            </div>

            <!-- Model -->
            <div class="vandm-field">
              <label class="vandm-label">Model</label>
              <div v-if="!apiError" class="vandm-select-wrap">
                <select v-model="model.model" class="vandm-select" :disabled="!models.length" @change="modelChanged()">
                  <option value="">Select model</option>
                  <option v-for="item in models" :key="item.name" :value="item.name">{{ item.name }}</option>
                </select>
                <svg class="vandm-select-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </div>
              <input v-else v-model="model.model" class="vandm-input" placeholder="Type model here" />
            </div>

            <!-- Odometer -->
            <div class="vandm-field">
              <label class="vandm-label">Odometer</label>
              <div class="vandm-input-wrap">
                <svg class="vandm-input-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                <input
                  v-model="odometer"
                  type="number"
                  class="vandm-input vandm-input--icon"
                  :class="{ 'vandm-input--valid': odometer && odometer > 0, 'vandm-input--error': odoerrview }"
                  placeholder="Mileage in KM"
                  :disabled="loading"
                />
                <span class="vandm-input-suffix">KM</span>
              </div>
            </div>

            <!-- Mileage error -->
            <transition name="fade">
              <div v-if="odoerrview" class="vandm-alert vandm-alert--danger vandm-alert--sm">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                <span>Sorry, the mileage is too high</span>
              </div>
            </transition>

            <!-- Submit -->
            <button
              :disabled="(!vin && !model.model) || !odometer || loading"
              class="vandm-btn"
              @click="submit"
            >
              <span v-if="!loading">Continue</span>
              <span v-else class="vandm-btn__loading">
                <svg class="vandm-spinner" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></svg>
                Checking vehicle…
              </span>
            </button>
          </div>

          <!-- Error block -->
          <div class="error hide">
            <div class="vandm-alert vandm-alert--danger vandm-alert--sm" style="margin-top: 12px;">
              <span>Vehicle not found — call <a class="vandm-tel" href="tel:+1-604-245-6680">(604) 245-6680</a></span>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="visible"
        class="vue-back-to-top"
        :style="`bottom:${this.bottom};left:${this.left};`"
      >
        <Main />
      </div>
    </transition>
  </div>
</template>

<script>
import $ from 'jquery'
import Loading from '../components/loading'

export default {
  name: 'VandM',
  components: {
    Loading,
  },
  props: {
    message: Boolean,
  },
  data() {
    return {
      apiError: false, // Add this property to track API errors
      qualifyAlert: false,
      step: 1,
      vandmvis: true,
      visible: false,
      rewidgvis: false,
      buttonShow: true,
      makes: [],
      models: [],
      trims: [],
      vin: '',
      odometer: null,
      odoerror: false,
      verror: false,
      styleObjectGreen: {
        border: '2px solid green',
        // backgroundColor: 'lightgreen'
      },
      styleOBjectRed: {
        border: '2px solid red',
        // backgroundColor: 'pink'
      },
      model: {
        year: '',
        make: '',
        model: '',
        trim: '',
      },
      years: [
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024,
        2025,
        2026,
      ],
      loading: false,
      odoerrview: false,
    }
  },
  computed: {
    computedInputStyleEnable() {
      // or use one method instead of computed property
      // apply your own logic at here to determinate if enable input-has-value-style
      return this.odometer && this.odometer.length > 0 ? this.styleObjectGreen : this.styleOBjectRed
    },
  },
  watch: {
    message: function() {
      if (true) {
        this.$nextTick(function() {
          this.$refs.vininput.focus()
        })
      }
    },
  },
  mounted() {
    $('.navbar').addClass('darkHeader')
    if (this.$refs.ymminput) this.$refs.ymminput.focus()
  },
  methods: {
    odometerreading() {
      if (this.odometer > 200000) {
        this.odoerror = true
        return (this.buttonShow = false)
      } else this.odoerror = false
      return (this.buttonShow = true)
    },
    closeWin() {
      return [(this.vandmvis = false), (this.visible = true)]
    },
    // closeApp() {
    //   if ('parentIFrame' in window) window.parentIFrame.close();
    //   return false;
    // },
    yearChanged() {
      const { year } = this.model
      this.model = {
        year,
        make: '',
        model: '',
        trim: '',
      }
      this.makes = []
      this.models = []
      this.trims = []
      if (!year) return
      this.axios
        .get(`${process.env.ROOT_API}/vehicle/search/makes?year=${year}`)
        .then(({ data }) => {
          const { makes } = data
          this.makes = makes
        })
        .catch(() => {
          this.apiError = true // Set apiError to true if there's an error
        })
    },
    makeChanged() {
      const { year, make } = this.model
      this.model = {
        year,
        make,
        model: '',
        trim: '',
      }
      this.models = []
      this.trims = []
      if (!make) return
      this.axios
        .get(`${process.env.ROOT_API}/vehicle/search/models?year=${year}&make=${make}`)
        .then(({ data }) => {
          const { models } = data
          this.models = models
        })
        .catch(() => {
          this.apiError = true
        })
    },
    modelChanged() {
      const { year, make, model } = this.model
      this.model = {
        year,
        make,
        model,
        trim: '',
      }
      this.trims = []
      if (!model) return

      const fetchTrims = new Promise((resolve, reject) => {
        this.axios
          .get(
            `${process.env.ROOT_API}/vehicle/search/trims?year=${year}&make=${make}&model=${model}`
          )
          .then(({ data }) => {
            const { trims } = data
            resolve(trims)
          })
          .catch(() => {
            reject(new Error('API error'))
          })
      })

      const timeout = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), 20000)
      )

      Promise.race([fetchTrims, timeout])
        .then(trims => {
          this.trims = trims !== null ? trims : 'Trim'
        })
        .catch(error => {
          this.apiError = true
          console.error(error.message)
        })
    },

    closereseize() {
      if ('parentIFrame' in window) window.parentIFrame.size(70)
      return false
    },
    widgresize() {
      if ('parentIFrame' in window) window.parentIFrame.size(340)
      return false
    },
    submit() {
      $('.error').addClass('hide')
      if (this.apiError) {
        const { year, make, model } = this.model
        console.log('loaded more than 17')
        this.odometer = 1000
        this.$store.state.userData.marketValue = 30000
        this.$store.state.userData.carDetails = year.toString().concat(' ', make, ' ', model)
        this.approvedLoan = 10000
        this.$store.state.userData.approvedLoanAmount = this.approvedLoan
        this.vandmvis = false
        this.rewidgvis = true
        this.$store.state.userData.step = 2
        this.widgresize()
      }
      if ((this.vin.length !== 17 && !this.model.model) || !this.odometer || this.loading) {
        return
      }
      if (this.odometer > 300000) {
        this.odoerrview = true
      } else {
        this.loading = true
        this.qualifyAlert = false
        this.$store.state.userData.vin = this.vin
        this.$store.state.userData.odometerReading = this.odometer
        const odometer = Math.round(this.odometer * 0.62)
        const { year, make, model, trim } = this.model
        this.$store.state.userData.year = year
        this.$store.state.userData.make = make
        this.$store.state.userData.model = model
        this.$store.state.userData.trim = trim
        if (year < 2017) {
          console.log('loaded less than 17')
          const url = this.vin
            ? `${process.env.ROOT_API}/vehicle/value?mileage=${odometer}&vin=${this.vin}`
            : `${process.env.ROOT_API}/vehicle/value?mileage=${odometer}&year=${year}&make=${make}&model=${model}&trim=${trim}`
          this.axios
            .get(url)
            .then(response => {
              const {
                mean,
                success,
                car_details: carDetails,
                certainty,
                max_loan_amount,
                low,
                high,
              } = response.data
              if (!success) {
                throw new Error('An error occurred')
              }
              const certaintyScore = certainty <= 1 ? Math.round(certainty * 100) : certainty

              // ✅ store market value + details from API
              this.$store.state.userData.marketValue = mean
              this.$store.state.userData.carDetails = carDetails

              // ✅ use server-approved amount (fallback if missing)
              this.approvedLoan = typeof max_loan_amount === 'number' ? max_loan_amount : 0
              this.$store.state.userData.max_loan_amount =
                typeof max_loan_amount === 'number' ? max_loan_amount : 0

              // ✅ apply min/max caps once
              this.$store.state.userData.approvedLoanAmount = Math.min(
                Math.max(this.approvedLoan, 1500),
                10000
              )
              this.approvedLoan = this.$store.state.userData.max_loan_amount

              // (optional) keep low/high for later UI if you want
              this.$store.state.userData.marketValueLow = low
              this.$store.state.userData.marketValueHigh = high

              if (
                carDetails.substring(0, 4) > 2006 &&
                odometer < 250000 &&
                certaintyScore > 40 &&
                this.approvedLoan > 500
              ) {
                this.odometer = odometer
                this.vandmvis = false
                this.rewidgvis = true
                this.$store.state.userData.step = 2
                this.widgresize()
              } else {
                this.loading = false
                this.vin = ''
                this.model = { year: '', make: '', model: '', trim: '' }
                this.odometer = null
                return [(this.verror = true), (this.buttonShow = false)]
              }
            })
            .catch(error => {
              console.log('loaded less than 17')
              this.odometer = 10000
              this.$store.state.userData.marketValue = 30000
              this.$store.state.userData.carDetails = year.toString().concat(' ', make, ' ', model)
              this.approvedLoan = 10000
              this.$store.state.userData.max_loan_amount = 1500
              this.$store.state.userData.approvedLoanAmount = this.approvedLoan
              this.vandmvis = false
              this.rewidgvis = true
              this.$store.state.userData.step = 2
              this.widgresize()
            })
        } else {
          console.log('loaded more than 17')
          console.log('vehicle ', year, make, model)
          this.odometer = 10000
          this.$store.state.userData.marketValue = 30000
          this.$store.state.userData.carDetails = year.toString().concat(' ', make, ' ', model)
          this.approvedLoan = 10000
          this.$store.state.userData.approvedLoanAmount = this.approvedLoan
          this.vandmvis = false
          this.rewidgvis = true
          this.$store.state.userData.step = 2
          this.widgresize()
        }
      }
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

/* ── Wrapper & Card ── */
.vandm-wrapper {
  display: flex;
  justify-content: center;
  padding: 0 12px;
}

.vandm-card {
  width: 100%;
  max-width: 440px;
  background: #fff;
  border-radius: 22px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.07);
  padding: 32px 28px 28px;
  font-family: 'Inter', sans-serif;
}

/* ── Header ── */
.vandm-header {
  text-align: center;
  margin-bottom: 20px;
}

.vandm-icon-wrap {
  width: 52px;
  height: 52px;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: #eef3ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vandm-title {
  font-weight: 700;
  font-size: 20px;
  color: #1e2a3a;
  margin: 0 0 4px;
}

.vandm-subtitle {
  font-size: 13px;
  color: #8a94a6;
  margin: 0;
}

/* ── Step indicator ── */
.vandm-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  margin-bottom: 24px;
}

.vandm-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.vandm-step__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #dde2ea;
  transition: background 0.25s, box-shadow 0.25s;
}

.vandm-step--active .vandm-step__dot {
  background: #4a7cff;
  box-shadow: 0 0 0 4px rgba(74, 124, 255, 0.18);
}

.vandm-step--done .vandm-step__dot {
  background: #34d399;
}

.vandm-step__label {
  font-size: 10px;
  font-weight: 600;
  color: #b0b7c3;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.vandm-step--active .vandm-step__label {
  color: #4a7cff;
}

.vandm-step--done .vandm-step__label {
  color: #34d399;
}

.vandm-step__line {
  flex: 1;
  height: 2px;
  min-width: 28px;
  background: #e4e8ee;
  margin: 0 6px;
  margin-bottom: 18px;
  border-radius: 999px;
  transition: background 0.25s;
}

.vandm-step__line--done {
  background: #34d399;
}

/* ── Form ── */
.vandm-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.vandm-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.vandm-label {
  font-size: 12px;
  font-weight: 600;
  color: #5a6478;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0;
}

/* ── Select ── */
.vandm-select-wrap {
  position: relative;
}

.vandm-select {
  width: 100%;
  padding: 11px 36px 11px 14px;
  border-radius: 12px;
  border: 1px solid #e0e4ec;
  background: #f8f9fb;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #1e2a3a;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  cursor: pointer;
}

.vandm-select:focus {
  border-color: #4a7cff;
  box-shadow: 0 0 0 3px rgba(74, 124, 255, 0.12);
  background: #fff;
}

.vandm-select:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.vandm-select-chevron {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

/* ── Input ── */
.vandm-input {
  width: 100%;
  padding: 11px 14px;
  border-radius: 12px;
  border: 1px solid #e0e4ec;
  background: #f8f9fb;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #1e2a3a;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.vandm-input:focus {
  border-color: #4a7cff;
  box-shadow: 0 0 0 3px rgba(74, 124, 255, 0.12);
  background: #fff;
}

.vandm-input--icon {
  padding-left: 38px;
  padding-right: 44px;
}

.vandm-input--valid {
  border-color: #34d399;
}

.vandm-input--valid:focus {
  box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.15);
}

.vandm-input--error {
  border-color: #f87171;
}

.vandm-input--error:focus {
  box-shadow: 0 0 0 3px rgba(248, 113, 113, 0.15);
}

.vandm-input-wrap {
  position: relative;
}

.vandm-input-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.vandm-input-suffix {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 600;
  color: #b0b7c3;
  pointer-events: none;
}

/* ── Alerts ── */
.vandm-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
}

.vandm-alert--danger {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.vandm-alert--sm {
  padding: 10px 12px;
  font-size: 12px;
}

/* ── Button ── */
.vandm-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #4a7cff 0%, #6366f1 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: transform 0.12s, box-shadow 0.12s, opacity 0.2s;
  margin-top: 4px;
}

.vandm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(74, 124, 255, 0.25);
}

.vandm-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.vandm-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.vandm-btn__loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* ── Spinner ── */
@keyframes vandm-spin {
  to { transform: rotate(360deg); }
}

.vandm-spinner {
  animation: vandm-spin 1s linear infinite;
}

/* ── Phone link ── */
.vandm-tel {
  color: #dc2626;
  font-weight: 700;
  text-decoration: underline;
}

.vandm-tel:hover {
  color: #b91c1c;
}

/* ── Error block (legacy) ── */
.error {
  padding: 0;
}

.error.hide {
  display: none;
}

/* ── Misc ── */
.vue-back-to-top {
  z-index: 1000;
  cursor: pointer;
  position: fixed;
  left: 0;
}

.container {
  padding-left: 0;
  padding-right: 0;
}

/* ── Transitions ── */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ── Responsive ── */
@media (max-width: 480px) {
  .vandm-card {
    padding: 24px 18px 22px;
    border-radius: 18px;
  }

  .vandm-steps {
    margin-bottom: 18px;
  }

  .vandm-step__label {
    font-size: 9px;
  }

  .vandm-step__line {
    min-width: 18px;
  }
}

/* Hide number input arrows */
.vandm-input[type='number']::-webkit-inner-spin-button,
.vandm-input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.vandm-input[type='number'] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/vandm.vue